<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:show="this.show"
                 v-bind:type="this.messageType" />

    <h1>Print Example CofA</h1>
    <label class="label">Product:</label>
    <AppProductSearch ref="child"  />
    <form class="exampleprint">


      <span class="label label--alt-inline" v-if="batches.length">{{ productcert }} | {{ productdesc }} </span>

      <span v-show="product">
        <label class="label">Batch No:</label>
        <selectize data-batch v-model="batch" :settings="selectizeSettings">
          <option :value="batch.name" v-bind:key="batch.name" v-for="batch in batches">{{ batch.name }}</option>
        </selectize>
      </span>

      <span v-show="batch">
        <label class="label">Cert Type:</label>
        <selectize v-model="cert" :settings="selectizeSettings">
          <option value="A">Analysis</option>
          <option value="C">Conformity</option>
        </selectize>
      </span>

      <div class="form-group">
        <button v-if="showPrintButton" :disabled="!isPrintEnabled" class="button button--alt" type="button" v-on:click="generatePdf()">Print</button>
      </div>
    </form>

  </div>
</template>

<script>
import Selectize from 'vue2-selectize';
import axios from 'axios';
  import AppMessages from '@/components/AppMessages/AppMessages.vue';
  import AppProductSearch from '@/components/AppProductSearch/AppProductSearch.vue';
  import SelectPopulate from '../mixins/SelectPopulate';
  import SearchObjects from '../mixins/SearchObjects';

export default {
  name: 'example',
  components: {
    Selectize,
    AppMessages,
    AppProductSearch

  },
  mixins: [SelectPopulate, SearchObjects],
  data() {
    return {
      selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
      },
      product: null,
      batch: 0,
      cert: '',
      batches: [],
      batchdata: [],
      productcert: '',
      productdesc: '',
      message: '',
      messageType: '',
      show: false,
      isPrintEnabled: true,
    };
  },
  mounted() {
    this.$watch(
      '$refs.child.selectedProduct',
      (newValue, oldValue) => (this.product = newValue)
    );
  },
  computed: {
    showPrintButton() {
      return this.batch && this.cert;
    }
  },
  watch: {
    product(value) {

      if (!value) {
        this.batch = 0;
        this.batches = [];
        this.cert = null;
        this.productcert = null;
        this.productdesc = null;
      }


      this.productcert = value.certType;
      this.productdesc = value.description;

      this.$Progress.start();

      this.batches = [];

      const url = `/products/${value.code}/batchnumbers/live`;
      axios
        .get(url)
        .then((r) => {
          const items = r.data;
          this.batches = items;
        })
        .catch((e) => {
          this.$Progress.fail();
        })
        .finally(() => this.$Progress.finish());
    },
  },
  methods: {
    generatePdf() {
      this.$Progress.start();
      this.show = false;

      let batchNo = '';

      if (this.batch != null) {
        batchNo = encodeURIComponent(this.batch);
      }

      const url = `/products/${this.product.code}/batches/${batchNo}/generate-cofa-pdf`;

      this.isPrintEnabled = false;

      axios.post(url, { CertType: this.cert }, { responseType: 'blob' })
        .then((response) => {
          const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', 'cofa.pdf');
          document.body.appendChild(link);
          link.click();

          setTimeout(() => {
            document.body.removeChild(link);
          }, 1000);

          this.message = 'Certificate has been generated';
          this.messageType = 'message message--success';
          this.show = true;
        })
        .catch(() => {
          this.message = 'Error generating Example CofA';
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
          this.isPrintEnabled = true;
        });
    },
    getUniqueKey(prefix, index) {
      return `${prefix}_${index}`;
    },
  },
};
</script>
